import { Component, OnInit } from '@angular/core'

@Component({
    selector: './achelous-overview',
    templateUrl: './achelous-overview.component.html',
    styleUrls: ['../../../../../help.component.css']
})

export class AchelousOverviewComponent implements OnInit {

    ngOnInit() {

    }
}